module.exports = __webpack_public_path__ + "static/media/5.86e8551a.png";